import { Component, Input, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as navigationData from '../../../../assets/json/dashboard-navigation.json';
import { HomepageService } from '../homepage.service';
import { CreatePersonaComponent } from '../create-persona/create-persona.component';
import { ImportPersonaComponent } from '../import-persona/import-persona.component';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';

@Component({
  selector: 'apc-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['./personas.component.scss', '../dashboard.component.scss'],
})
export class PersonasComponent {
  public navigation = (navigationData as any).default;
  public defaultColumns = [
    { name: 'status'},
    { name: 'company_uid' },
    { name: 'employment_start' },
    { name: 'employment_end' },
    { name: 'name' },
    { name: 'hierarchy_l1' },
    { name: 'hierarchy_l2' },
    { name: 'hierarchy_l3' }
  ];
  public columnsToExclude = ['persona_identifier', 'seniority'];
  public columnsNotToFilter = ['created_at', 'updated_at', 'status'];
  public createPersonaModalRef: NgbModalRef;
  public importPersonaModalRef: NgbModalRef;
  public isArchived: boolean;

   public buttons =[
    {
      key: 'create',
      svg: 'assets/ico/user-regular.svg',
      permission: {
        pertinence: 'persona',
        section: 'profile',
        context: 'create',
        type: 'MANAGER',
      },
      tooltipMessageKey: 'dashboard.persona.new.button',
    },
    {
      key: 'import',
      svg: 'assets/ico/import-persona.svg',
      permission: {
        pertinence: 'persona',
        section: 'profile',
        context: 'import',
        type: 'MANAGER',
      },
      tooltipMessageKey: 'dashboard.persona.new.import',
    },
  ];
  constructor(public homepageService: HomepageService, public modalService: NgbModal, public userPersonSharedService: UserPersonSharedService) {
    this.isArchived= false;
  }
 
  ngOnInit(){
    this.userPersonSharedService._isArchived$.next(this.isArchived);
  }

  createElement(key: string) {
    if (key == 'create') {
      this.createPersonaModalRef = this.modalService.open(CreatePersonaComponent, {
        ariaLabelledBy: 'modal-basic',
        backdrop: 'static',
        keyboard: false,
      });
      this.createPersonaModalRef.componentInstance.modalRef = this.createPersonaModalRef;
    } else if (key == 'import') {
      this.importPersonaModalRef = this.modalService.open(ImportPersonaComponent, {
        ariaLabelledBy: 'modal-basic',
        backdrop: 'static',
        keyboard: false,
      });
      this.importPersonaModalRef.componentInstance.modalRef = this.importPersonaModalRef;
    }
  }
}
